import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';
import type { ClientGridCard as ClientGridCardData } from '@/shared/types/client';
import { Badge } from '@/shared/ui/badge';
import { Button } from '@/shared/ui/button';
import { Card } from '@/shared/ui/card';
import { CLIENT_KIND_LABELS, CLIENT_LIFECYCLE_LABELS } from '../api/use-clients';

interface ClientGridCardProps {
  card: ClientGridCardData;
}

export function ClientGridCard({ card }: ClientGridCardProps) {
  return (
    <Card className="overflow-hidden">
      <div
        className="flex h-20 items-center justify-center p-3"
        style={{ backgroundColor: card.backgroundColor ?? 'hsl(var(--muted))' }}
      >
        <img
          src={card.logoUrl}
          alt={card.name}
          className="max-h-full max-w-full object-contain"
          loading="lazy"
          onError={(e) => {
            e.currentTarget.style.display = 'none';
          }}
        />
      </div>
      <div className="space-y-2.5 p-4">
        <div className="flex flex-wrap items-start justify-between gap-2">
          <h3 className="line-clamp-2 text-sm font-semibold leading-snug">{card.name}</h3>
          <Badge variant={card.inactive ? 'destructive' : 'success'} className="shrink-0 font-normal">
            {card.inactive ? 'Inativo' : 'Ativo'}
          </Badge>
        </div>
        <div className="flex flex-wrap gap-1.5">
          {card.lifecycleStatus ? (
            <Badge variant="secondary" className="font-normal">
              {CLIENT_LIFECYCLE_LABELS[card.lifecycleStatus]}
            </Badge>
          ) : null}
          {card.clientKind ? (
            <Badge variant="outline" className="font-normal">
              {CLIENT_KIND_LABELS[card.clientKind]}
            </Badge>
          ) : null}
        </div>
        <div className="flex flex-wrap gap-2">
          <Button variant="secondary" size="sm" asChild>
            <Link to={`/clientes/${card.id}`}>Configurar</Link>
          </Button>
          <Button size="sm" asChild>
            <Link to={`/loja/${card.passbookId}`}>
              <ExternalLink className="size-4" /> Inspecionar
            </Link>
          </Button>
        </div>
      </div>
    </Card>
  );
}
